<template>
	<b-modal
		id="git-merge-dialog"
		:modal-class="theme"
		ref="gitMergeModal"
		size="xl"
		:title=" (mergeDialogSettings.readonly ? '' : 'Merge ') + mergeDialogSettings.fileName"
		no-close-on-backdrop
		:dialog-class="'full-screen-modal-dialog'"
		:body-class="{'git-merge-body': true, 'landscape': landscape }"
	>
		<GitMerge  
			ref="gitMerge" 
			:synchronousScrolling="synchronousScrolling"  
			:left="mergeDialogSettings.left" 
			:right="mergeDialogSettings.right" 
			:final="final" 
			:readonly="mergeDialogSettings.readonly" 
			@change="setFinal"
		/>
		<template #modal-footer>
			<div class="d-flex w-100 justify-content-between">
				<div class="d-flex align-items-center" style="gap: 0.5em;">
					<button 
						class="btn btn-icon-toggle p-2"
						:class="{'btn-primary': !landscape, 'btn-secondary': landscape}"  
						title="Portrait"
						@click="landscape=false"
					>
						<i class="fas fa-arrows-up-down"></i>
					</button>
					<button 
						class="btn btn-icon-toggle p-2"
						:class="{'btn-primary': landscape, 'btn-secondary': !landscape}"  
						title="Landscape"
						@click="landscape=true"
					>
						<i class="fas fa-arrows-left-right"></i>
					</button>

					<b-form-checkbox class="ml-4" v-if="mergeDialogSettings.left != null" v-model="synchronousScrolling">
						Synchronous Scrolling
					</b-form-checkbox>
				</div>
				<div>
					<button v-if="!mergeDialogSettings.readonly" class="btn btn-primary" type="button" :disabled="loading" @click="submit()">
						<span
							v-if="loading"
							class="spinner-border spinner-border-sm mr-2"
							role="status"
							aria-hidden="true"
						></span>
						Submit
					</button>
					<button class="btn btn-secondary" type="button" @click="close()">
						{{mergeDialogSettings.readonly ? 'Close' : 'Cancel'}}
					</button>
				</div>	
			</div>
		</template>

	</b-modal>
	
</template>

<script>
import GitMerge from './GitMerge'
import ThemeService from '../../services/theme';

export default {
	name: "GitMergeDialog",
	components: {
		GitMerge
	},
	props: ['mergeDialogSettings'],
	data() {
		return {
			final: null,
			loading: false,
			synchronousScrolling: true,
			landscape: false
		};
	},
	watch: {
		mergeDialogSettings(newVal) {
			this.final = newVal && newVal.final;
		}
	},
	created() {
		this.theme = ThemeService.instance().getTheme() || 'light';
		this.listenForThemeChanges();
	},
	methods: {		
		listenForThemeChanges: function () {
			ThemeService.instance().events.on("themechanged", () => {
				this.theme = ThemeService.instance().getTheme();
			});
		},
		open() {
			this.loading = false;
			this.$refs.gitMergeModal.show();
		},
		close() {
			this.$refs.gitMergeModal.hide();
		},
		submit() {
			this.loading = true;
			if (this.final != null) {
				this.$emit("submit", this.final);
			}
			this.loading = false;
			this.$refs.gitMergeModal.hide();
		},
		setFinal(code) {
			this.final = code;
		}
	}
};
</script>

<style>

.git-merge-body {
	height: calc(100% - 50px);
	overflow: hidden;
}

.git-merge-body.landscape {
	height: 100%;
}

.btn-icon-toggle {
	min-width: 3rem;
}

</style>